<template>
    <el-dialog :visible="visible" :modal-append-to-body="false" class="ah-detail-dialog bulk-setup-statement-dialog" append-to-body width="500px" :before-close="onClose" @open="onOpen">
        <template slot="title"> 收支項目範本 </template>
        <div class="detail-row">
            <el-form>
                <el-form-item label="參考版本">
                    <el-select v-model="selectSample" placeholder="請選擇參考版本" @change="onChangeProgram">
                        <el-option v-for="item in templateList" :key="item.id" :label="item.label" :value="item.id" />
                    </el-select>
                </el-form-item>
            </el-form>
            <el-tree ref="tree" :data="data" show-checkbox node-key="iteM_NAM" highlight-current :props="defaultProps" v-loading="isLoading"> </el-tree>
            <center class="actions" style="margin-top: 30px">
                <el-button type="primary" class="primary-action" @click="onSubmit"> 建立 </el-button>
            </center>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import { statementTypes } from '@/assets/commonData/options';
import Firebase from '@/utils/firebaseSDK';

const firebase = new Firebase();

export default {
    props: {
        visible: Boolean,
    },
    data() {
        return {
            currentStatementList: [],
            isLoading: false,
            selectSample: null,
            templateList: [],
            data: [],
            defaultProps: {
                children: 'children',
                label: (data) => `${data.iteM_NAM}${data.isshare ? '（鏡像）' : ''}`,
            },
            dataList: [],

            accountingSettings: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const { idList, dataList } = await firebase.getListImportFormat();
            this.templateList = idList;
            this.dataList = dataList;

            const resp = await this.$api({
                url: 'Tool/GetAccountingSettings',
                method: 'GET',
            });

            _.forEach(resp.data, (item) => {
                this.accountingSettings.push(..._.map(item, (o) => ({ accno: o.accno, sno: o.sno })));
            });
        },
        async onChangeProgram(val) {
            try {
                this.isLoading = true;
                const currList = await this.getList();
                const foundList = this.dataList[val];

                this.data = _.cloneDeep(foundList);

                this.data.forEach((setting) => {
                    const CURR_GROUPS = currList[setting.key];
                    CURR_GROUPS.forEach((group) => {
                        const settingGroup = _.find(setting.children, ['iteM_NAM', group.iteM_NAM]);
                        if (settingGroup) {
                            group.childSettings.forEach((item) => {
                                const settingItem = _.find(settingGroup.children, ['iteM_NAM', item.iteM_NAM]);
                                // 檢查子項目是否已存在
                                if (settingItem) settingItem.disabled = true;
                            });

                            // 檢查該大群組是否已包含所有子項目
                            const DISABLED_ITEM_LENGTH = _.filter(settingGroup.children, ['disabled', true]).length;
                            if (DISABLED_ITEM_LENGTH === settingGroup.children.length) {
                                settingGroup.disabled = true;
                            }

                            // 檢查該類型是否已包含所有大群組
                            const DISABLED_GROUP_LENGTH = _.filter(setting.children, ['disabled', true]).length;
                            if (DISABLED_GROUP_LENGTH === setting.children.length) {
                                _.set(setting, 'disabled', true);
                            }
                        }
                    });
                });
            } finally {
                this.isLoading = false;
            }
        },
        async onSubmit() {
            this.isLoading = true;
            try {
                const checkedNode = this.$refs.tree.getCheckedNodes(false, true);

                const groupsCreated = await this.createGroups(checkedNode);
                const itemsCreated = await this.createItems(checkedNode);
                this.$emit('refresh');
                this.onShowMsg(groupsCreated, itemsCreated);
                this.onClose();
            } finally {
                this.isLoading = false;
            }
        },

        async getList() {
            const resp = await this.$api({
                url: 'Tool/GetIncomeStatementSettings',
                method: 'GET',
            });

            return resp.data;
        },

        async createGroups(checkedNode) {
            let count = 0;
            const incomeStatementSettings = await this.getList();
            const categories = _.chain(checkedNode)
                .filter((o) => o.grP_NAM)
                .value();
            // eslint-disable-next-line no-restricted-syntax
            for (const category of categories) {
                const typeName = _.find(statementTypes, ['type', category.type]).key;
                const EXISTED = _.find(incomeStatementSettings[typeName], ['iteM_NAM', category.iteM_NAM]);
                if (!EXISTED) {
                    count += 1;
                    // eslint-disable-next-line no-await-in-loop
                    await this.$api({
                        url: '/IncomeStatementSettingPage/AddGroup',
                        method: 'POST',
                        data: {
                            type: category.type,
                            iteM_NAM: category.iteM_NAM,
                            grP_NAM: category.grP_NAM,
                            grP_MEM: category.grP_MEM,
                            isshare: category.isshare,
                        },
                    });
                }
            }
            return count;
        },

        async createItems(checkedNode) {
            let count = 0;
            const incomeStatementSettings = await this.getList();
            const items = _.chain(checkedNode)
                .filter((o) => o.parentName)
                .map((o) => ({
                    ...o,
                    fsno: _.find(incomeStatementSettings[o.key], ['iteM_NAM', o.parentName]).sno,
                }))
                .value();
            // eslint-disable-next-line no-restricted-syntax
            for (const item of items) {
                const EXISTED = _.chain(incomeStatementSettings[item.key]).find(['iteM_NAM', item.parentName]).get('childSettings').find(['iteM_NAM', item.iteM_NAM])
                    .value();

                if (!EXISTED) {
                    count += 1;
                    const accsno = _.find(this.accountingSettings, ['accno', item.accno])?.sno;
                    // eslint-disable-next-line no-await-in-loop
                    await this.$api({
                        url: '/IncomeStatementSettingPage/AddItem',
                        method: 'POST',
                        data: {
                            fsno: item.fsno,
                            iteM_NAM: item.iteM_NAM,
                            grP_MEM: item.grP_MEM,
                            accsno,
                            suggestedAccItems: _.map(item.suggestedAccItems, 'accno'),
                        },
                    });
                }
            }
            return count;
        },

        async onShowMsg(groupsCreated, itemsCreated) {
            let message;
            if (groupsCreated + itemsCreated === 0) {
                message = '已完成';
            } else if (groupsCreated === 0) {
                message = `已建立${itemsCreated}個子項目`;
            } else if (itemsCreated === 0) {
                message = `已建立${groupsCreated}個大群組`;
            } else {
                message = `已建立${groupsCreated}個大群組及${itemsCreated}個子項目`;
            }

            try {
                await this.$msgbox({
                    title: '',
                    message,
                    confirmButtonText: '確定',
                    closeOnClickModal: false,
                    beforeClose: this.goToHome,
                });
            } catch (e) {
                console.log(e);
            }
        },

        async onOpen() {
            this.selectSample = _.head(this.templateList).id;
            await this.onChangeProgram(this.selectSample);
        },
        onClose() {
            this.$refs.tree.setCheckedNodes([]);
            this.data = [];
            this.$emit('close');
        },
    },
};
</script>
